"use client";

import { useEffect } from "react";

import { track } from "@/integrations/posthog/events";
import type { AppLocale } from "@/i18n/routing";

interface ArticleViewedTrackerProps {
  slug: string;
  locale: AppLocale;
  tags: string[];
}

export function ArticleViewedTracker({
  slug,
  locale,
  tags,
}: ArticleViewedTrackerProps) {
  useEffect(() => {
    track("article_viewed", { slug, locale, tags });
    // Mount-only capture: pageview-style exception to the no-effects rule.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
